import type { IForemanApiKey } from '@/types/core/ForemanApiKey'
import type { IForemanApiKeyForm } from '@/types/core/forms'

import axios from 'axios'

export async function getForemanApiKey(): Promise<IForemanApiKey | null> {
  const res = await axios.get(import.meta.env.VITE_APP_CORE_FOREMAN_API_KEYS_ENDPOINT)

  if (res.status == 204) {
    return null
  }

  return res.data
}

export async function deleteForemanApiKey(id: number): Promise<any> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_CORE_FOREMAN_API_KEYS_ENDPOINT}`, { data: { id: id } })
  return res.data
}

export async function createForemanApiKey(form: IForemanApiKeyForm): Promise<any> {
  const res = await axios.post(import.meta.env.VITE_APP_CORE_FOREMAN_API_KEYS_ENDPOINT, form)
  return res.data
}
